import React from 'react';
import { a as useSafeLayoutEffect$1 } from './useSafeLayoutEffect-7WC_06jN.js';

var useIsMounted$1 = {};

var useSafeLayoutEffect = {};

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.useSafeLayoutEffect = void 0;
	var useSafeLayoutEffect_1 = useSafeLayoutEffect$1;
	Object.defineProperty(exports, "useSafeLayoutEffect", { enumerable: true, get: function () { return useSafeLayoutEffect_1.useSafeLayoutEffect; } }); 
} (useSafeLayoutEffect));

Object.defineProperty(useIsMounted$1, "__esModule", { value: true });
var useIsMounted_2 = useIsMounted$1.useIsMounted = void 0;
const react_1 = React;
const useSafeLayoutEffect_1 = useSafeLayoutEffect;
/**
 * Why does this work?
 *
 * The following is from the react docs:
 *    [The return function from `useLayoutEffect`] is the optional cleanup mechanism for effects.
 *    Every effect may return a function that cleans up after it.
 *
 *    When exactly does React clean up an effect? React performs the cleanup when the component unmounts.
 *    The cleanup for useLayoutEffect is called after component unmounts and before before browser painting
 *    the screen
 *
 * What does that mean for us? When this hook is initially loaded, we then trigger a `useLayoutEffect` that
 * sets the isMounted to true right after the component is mounted.
 * When the component unmounts, it calls the cleanup function that sets `isMounted` to false.
 * This `useLayoutEffect` hook will only be run once.
 */
function useIsMounted() {
    const isMounted = (0, react_1.useRef)(false);
    (0, useSafeLayoutEffect_1.useSafeLayoutEffect)(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}
useIsMounted_2 = useIsMounted$1.useIsMounted = useIsMounted;

export { useIsMounted_2 as u };
